import * as ol from 'openlayers'
import { DataTheme } from 'src/Enums'
import { ContextTag } from '../wiki/Wiki'
import { GeoLayer, AbstractLayer, AbstractLayerOptions } from './Layer'
import { layerCopyrights, LayerDescription, LayerGroup, LayerParamsObject, LayerType } from './LayerRegistry'

/**
 * Map layer class for the Natura 2000 Protected Forest Areas WMS source from MiljøGIS.
 */
class ForestProtectionLayer extends AbstractLayer implements GeoLayer {
  static readonly defaultParams: LayerParamsObject = {
    opacity: 0.5
  }

  constructor (options: any) {
    const defaultOptions: AbstractLayerOptions = {
      layerType: LayerType.FOREST_PROTECTION,
      enabled: true,
      minZoom: 0,
      zIndex: 1
    }
    super({ ...defaultOptions, ...options })

    let { opacity } = options.params
    opacity = opacity === undefined ? ForestProtectionLayer.defaultParams.opacity : opacity

    this.olLayer = new ol.layer.Image({
      visible: this.enabled,
      opacity: opacity,
      source: new ol.source.ImageWMS({
        url: 'https://tilecache7-miljoegis.mim.dk/gwc/service/wms',
        params: {
          LAYERS: 'theme-np3b_2020-fredskov',
          transparent: 'TRUE',
          srs: 'EPSG:25832'
        },
        projection: new ol.proj.Projection({
          code: 'EPSG:25832'
        }),
      })
    })
  }

  static describe (): LayerDescription {
    return {
      type: LayerType.FOREST_PROTECTION,
      name: 'map.layer.forestprotection',
      group: LayerGroup.NATURE,
      contextTags: [
        ContextTag.FOREST_PROTECTION
      ],
      themes: [DataTheme.ENVIRONMENT],
      capabilitiesUrl: '',
      legendEnabled: false,
      opacityEnabled: true,
      layerCopyright: layerCopyrights.MST
    }
  }
}

export default ForestProtectionLayer
